// GENERATED FILE - DO NOT MODIFY

export enum GetAmenitiesSortColumnDto {
    Order = "Order",
    Name = "Name",
    PricePerBlock = "PricePerBlock",
    IsApprovalRequired = "IsApprovalRequired",
    CategoryName = "CategoryName",
}